module.exports = {

    save:       'Salvar',
    saved:      'Guardado',
    close:      'Close',
    prev:       'Anterior',
    next:       'Seguinte',
    cancel:     'Cancelar',
    back:       'Voltar',
    thanks:     'Obrigado!',
    send:       'Enviar',
    show_less:  'Mostrar menos',
    show_more:  'Mostrar mais',
    perfect:    'Perfeito!',
    awesome:    'Ótimo!',
    hello_im:   'Olá, sou {0}',
    hello:      'Olá',

    labels : {
        user_name:       'Seu nome',
        user_email:      'Seu email',
        user_phone:      'Seu telefone',
        comments:        'Comentários adicionais',
        date:            'Seleciona uma data',
        budget_from:     'Desde',
        budget_to:       'a',
        amount:          'Total',
        currency:        'Moeda',
        selection:       'Sua seleção',
        choice_one:      'Seleciona um',
        choice_city:     'Seleciona uma cidade',
        choice_event:    'Seleciona um evento',
        days_count:      '{count} dia | {count} dias',
        days_more:       'mais de {count} dia | mais de {count} dias',
        day_x:           'Dia {0}',
        total:           'Total',
        hostesses_count: '{count} promotora | {count} promotoras',
        hostesses_more:  'mais de {count} promotora | mais de {count} promotoras',
        guests:          '{count} convidado | {count} convidados',
        services:        '{count} serviço | {count} serviços',
        meals:           '{count} refeição | {count} refeições',
        period:          '{count} período | {count} períodos',
        city:            'Cidade',
        web:             'Página Web'
    },

    terms_label:       'Lí e aceito o {0}',
    terms_link_label:  'Política de Privacidade',

    errors : {

        area      : '¿Que superfície tem o stand?',
        user_name : 'O campo nome é obrigatório',
        user_email: 'Se requer um email válido',
        user_phone: 'O campo telefone é obrigatório',
        estimate:   'An estimate is requierd',
    },

    rq : {

        stands : {


            labels : {
                city: 'Cidade onde necassita o Stand',
                event: 'Em que feira expõe?',
                size: 'Tamanho do stand',
                price_rank:       'Faixa de preços',
                price_rank_help : 'Para fazer uma correta seleção de materiais para o projeto de seu stand, nos indique por favor a faixa de preços que você quer que trabalhemos.',
            },

            thanks : {
                title : 'Obrigado!',
                text  : 'Enviaremos em 48h uma seleção das melhores propostas',
            },

            options_has_design : {

                0 : 'Projeto + Construção',
                1 : 'Somente construção',
                2 : 'Outros serviços'
            },

            page_start_title:     'Solicitação de Stand',
            page_start_subtitle : 'Características',
            page_start_options_has_design :{

                0: 'Necessito o projeto do stand, sua construção e montagem',
                1: 'Já conto com o projeto do stand, somente necessito sua construção e montagem',
                2: 'Outros',
            },

            page_user_title:      'Seus dados de contato',
            page_user_subtitle:   '',

            page_price_title:     'Faixa de preços',
            page_price_subtitle : '',

            page_space_title:    'Você já tem confirmado o espaço na feira?',
            page_space_subtitle: '',
            page_space_options : {

                0: 'Não, ainda estou avaliando se vou expor e me interessa saber os custos de um stand',
                1: 'Sim, já tenho o espaço e a localização confirmados',
            },

            page_type_title    : 'Nos indique que tipo de stand está buscando',
            page_type_subtitle : '',
            page_type_options : {
                design:  'Projeto de Stand',
                modular: 'Stand Modular',
                mixed :  'Stand Mixto',
                display: 'Stand Display',
                none:     'Ainda não sei'
            },

            page_properties_title:     'Que elementos ou espaços necessita em seu stand?',
            page_properties_subtitle : 'Você pode selecionar quantos necessitar',
            page_properties_options: {
                counter:            'Mostrador',
                furniture:          'Mobiliário',
                multimedia:         'Aluguel de multimedia',
                closedMeetingRoom:  'Sala de reuniões fechada',
                openMeetingRoom:    'Espaço de armazenagem',
                spaceStorage:       'Sala de reuniões aberta',
                cateringArea:       'Área de catering',
                hangingElements:     'Elementos suspensos',
            },

            page_staff_title:               'How many employees will be in the stand during the event?',
            page_staff_subtitle:            'Specify the number of employees, what position they have, that are going to be in the stand. This information is helpfull for designing the stand. Example: manager + 3 sales person + hostesses',

            page_price_relevance_title :    'How relevant is the price in your purchase decision?',
            page_price_relevance_subtitle : 'Price and design are two sides of the same coin, with a bigger budget more investment in the design and the materials to build the stand. Tell us how important is each of this aspects',
            page_price_relevance_options  : {

                label1 : 'Relevance:',
                label2 : 'Minimum',
                label3 : 'Low',
                label4 : 'Medium',
                label5 : 'High',
                label6 : 'Maximum',
                label7 : 'Price',
                label8 : 'Design',
            },

            page_price_max_title:    'Budget and currency',
            page_price_max_subtitle: 'You selected the price as the most important aspect. What is the maximun budget?',

            page_upload_alt_title:    'Do you want to attach some design, idea or concept of how your stand should be? This would help us to understand better what do you have in mind.',
            page_upload_alt_subtitle: '',

        },

        hostesses : {


            thanks : {
                title : 'Obrigado!',
                text  : 'Por favor, nos envie seu CV a CV.hostesses@neventum.com e enviaremos nossas agências associadas',
            },

            create : {

                1 : {
                    title:       'Solicitação de Promotoras',
                    subtitle:    'Em qual cidade e evento você necessita o serviço',
                    label1:      'Em que cidade necessita as promotoras?',
                    label2:      'Indique o nome do evento',
                    placeholder: 'Escreva ou seleciona um elemento',
                },

                2 : {
                    title         : 'Poderia confirmar esta informação, por favor?',
                    label1        : 'Confirmar cidade',
                    label2        : 'Confirmar data de início',
                },
                3 : {
                    'title'         : 'Solicitação de Promotoras',
                    'subtitle'      : 'Seus dados de contato',
                },
                4 : {
                    'title'         : 'Para oferecer um melhor serviço, por favor nos indique qual é o seu perfil.',
                    'label1'        : 'Sou um <b>Cliente</b> que solicita um serviço de promotoras',
                    'label2'        : 'Sou uma <b>Agência</b> que requer promotoras para um cliente',
                    'label3'        : 'Sou uma <b>Promotora</b> buscando trabalho e quer enviar seu CV',
                },
                5 : {
                    'title'         : 'Indique quantas promotoras necessita e durante quantos dias.',
                    'label1'        : 'Promotoras requeridas',
                    'label2'        : 'Dias requeridos',
                    'label3'        : 'Lamentavelmente não encontramos o evento em nossa base de dados, por favor nos indique sua data de início',
                },
                6 : {
                    'title'         : 'Quantas horas ao dia você necessita o serviço de promotoras',
                    'option1'       : '1 hora',
                    'option2'       : '{0} horas',
                    'option3'       : 'Mais de 8 horas',
                },
                7 : {
                    'title'         : 'Aproximadamente quantas horas ao dia necessitas o serviço de promotoras',
                    'option1'       : '1 hora',
                    'option2'       : '{0} horas',
                    'option3'       : 'mais de 8 horas',
                },
                8 : {
                    'title'         : 'Que tipo de tarefas as promotoras devem desempenhar?',
                    'body'          : 'Exemplo: necessito promotoras de imagen que permaneçam no mostrador do stand e que eventualmente distribuam flyers na feira e uma promotora bilingüe que nos ajude com as gestões comerciais, ...',
                },
                9 : {
                    'title'         : 'Idiomas requeridos',
                    'body'          : 'Selecione e/ou indique os idiomas requeridos',
                    'label1'        : 'Espanhol',
                    'label2'        : 'Italiano',
                    'label3'        : 'Francês',
                    'label4'        : 'Inglês',
                    'label5'        : 'Alemão',
                    'label6'        : 'Português',
                    'label7'        : 'Outros',
                },

                'errors' : {
                    'city'              : 'Selecione uma cidade',
                    'event'             : 'Selecione um evento',
                    'userName'          : 'Você deve introduzir o nome de usuário',
                    'userEmail'         : 'Você deve introduzir o email',
                    'userPhone'         : 'Você deve introduzir o número de telefone',
                    'invalidEmail'      : 'Você deve introduzir um email válido',
                    'profile'           : 'Selecione um perfil',
                    'countHostesses'    : 'Quantas promotoras você necessita?',
                    'countDays'         : 'Quantos dias estará?',
                    'deadline'          : 'Introduza a data do evento',
                    'days'              : 'Complete a jornada de todos os dias',
                    'hoursAvg'          : 'Complete as horas de jornada',
                    'tasks'             : 'Que tarefas as promotoras terão?',
                    'langs'             : 'Que idiomas as promotoras necessitan saber?',
                    'otherLang'        : 'Introduza outros idiomas',
                }
            }

        },

        catering : {

            thanks : {
                title         : 'Obrigado!'
            },

            guests: 'Convidados',

            1 : {
                title         : 'Solicitação de Catering',
                subtitle      : 'Em que cidade e evento você necessita o serviço',
                label1        : 'Em que cidade você necessita promotoras?',
                label2        : 'Indique o nome do evento',
                placeholder   : 'Escreva ou selecione um elemento',
            },
            2 : {
                title         : 'Solicitação de Promotoras',
                subtitle      : 'Seus ddos de contato',
                placeholder1  : 'Seu nome',
                placeholder2  : 'Seu email',
                placeholder3  : 'Seu telefone',
            },
            3 : {
                title:      'Indique durante quantos dias você necessita o serviço de catering',
                label_days: 'Dias requeridos',
                label_date: 'Lamentavelmente não encontramos o evento em nossa base de dados, por favor nos indique a data de início',

            },
            4 : {
                title         : 'Quantos convidados você espera?',
            },

            5 : {
                title: 'Quantos convidados você espera ter por dia?',
            },
            6 : {
                title         : 'Aproximadamente, quantos convidados você espera ter cada dia?',
            },
            7 : {
                title         : 'Que tipo de serviço você está buscando?',
                title2        : 'Em que horário você necessita o catering?',
                label1        : 'Buffet durante o evento',
                label2        : 'CofeeBreak',
                label3        : 'Pratos principais',
                label4        : 'Todo o dia',
                label5        : 'Café da manhã',
                label6        : 'Almoço',
                label7        : 'Janta',
            },
            8 : {
                title         : 'Quais serviços se deve incluir no orçamento?',
                label1        : 'Garçons',
                label2        : 'Refrescos e cafés',
                label3        : 'Bebidas alcoólicas',
                label4        : 'Almoço',
                label5        : 'Mobiliário',
                label6        : 'Talheres, copos, ...',
            },
            9 : {
                title         : 'Orçamento',
                label1        : 'Orçamento por convidado',
                label2        : 'Orçamento global do evento',
                text1         : 'Por favor nos indique o orçamento máximo global que você considera para podermos apresentar a melhor opção de catering, nesta faixa de preços',
                text2         : 'or favor nos indique o orçamento máximo por convidado que você considera para podermos apresentar a melhor opção de catering, nesta faixa de preços',
            },
            10 : {
                title         : 'Você que adicionar algo mais?',
                subtitle      : 'Se requer alimentos especiais, intolerâncias, algum tipo de menú, ....'
            },

            labels : {

                service   : {
                    buffet        : 'Buffet',
                    coffeeBreak   : 'Descanso',
                    mainDishes    : 'Pratos principais',
                },
                period    : {
                    allday        : 'Durante todo o evento',
                    breakfast     : 'Café da manhã',
                    lunch         : 'Almoço',
                    dinner        : 'Janta',
                },
                budgetType : {
                    byGuest : 'Orçamento por convidado',
                    global  : 'Orçamento global'
                }
            },

            errors : {
                city:         'Selecione uma cidade',
                event:        'Selecione um evento',
                userName:     'Você deve introduzir um nome de usuário',
                userEmail:    'Você deve introduzir o email',
                userPhone:    'Você deve introduzir o número de telefone',
                invalidEmail: 'Você deve introduzir um email válido',
                days:         'Você deve selecionar quantos dias são requeridos',
                deadline:     'Introduza a data do evento',
                guests:       'Você deve introduzir o nome de convidados',
                daysResume:   'Você deve introduzir o número de convidados por dia',
                guestsAvg:    'Você deve introduzir o nome de convidados',
                period:       'Selecione um horário',
                service:      'Selecione um serviço',
                budgetType:   'SSelecione uma opção para o orçamento',
                budget:       'Introduza o orçamento máximo',
                budgetFormat: 'O orçamento máximo deve ser um número inteiro'
            }

        }
    },

    corporation : {

        suppliers : {

            page_navbar_my_brand    : 'Minha marca:',
            page_navbar_data        : 'Data',
            page_navbar_presentation: 'Apresentação',
            page_navbar_geo         : 'Onde trabalhas',
            page_navbar_stands      : 'Meus stands',
            page_navbar_office      : 'Escritório',
            page_navbar_scopes      : 'Ambito',

            page_related_is_other       : 'Criar nova empresa',
            page_related_is_this        : 'Esta é minha empresa',
            page_related_created_by     : 'Perfil criado por {0} em {1}',
            page_related_not_suggested  : 'Minha empresa não coincide com as sugeridas, quero continuar com o processo de alta:\n',

            page_resolution_label_1     : 'Não façam <b>nada</b>, resolveremos internamente',
            page_resolution_label_2     : '{0} seguirá gerenciando a marca no entanto  <b> eu quero permissões para atualizar o conteúdo, receber leads </b>, ...',
            page_resolution_label_3     : '{0} ormai non è più il responsabile di gestire il contenuto, <b>da adesso sono io responsabile</b> di questo contenuto',

            labels                  : {
                name                : 'Nome de sua empresa',
                city                : 'Cidade',
                sector              : 'Setor de atividade',
                address             : 'Página Web',
                web                 : 'Endereço',
            },

            alerts : {

                group_suppliers_text_1  : '<b>Esta é sua empresa?</b>',
                group_suppliers_text_2  : 'Alguém de sua empresa possui um perfil em neventum - o detectamos através de seu email corporativo -',
                group_suppliers_text_3  : 'Pensamos que se você deseja criar um outro perfil, você economiza trabalho ;)',
                group_suppliers_text_4  : 'Se deseja criar esta empresa nos avise e solicite, se quiser, mais permissões para editar. Se você é outra empresa, por favor nos indique e seguimos com o processo de alta.',

                other_suppliers_text_1  : '<b>Esta é sua empresa?</b>',
                other_suppliers_text_2  : 'Com base à informação fornecida de sua empresa, encontramos algumas marcas parecidas em neventum.',
                other_suppliers_text_3  : 'Para evitar que se duplique marcas que já tenham sido criadas por um colega, explicamos em seguida.',
                other_suppliers_text_4  : 'Se deseja criar esta empresa nos avise e solicite, se quiser, mais permissões para editar. Se você é outra empresa, por favor nos indique e seguimos com o processo de alta.',

                resolution_text_1        : '<b>Ótimo!</b>',
                resolution_text_2        : 'Somente nos falta saber quem irá gerenciar sua marca a partir de agora: você, seu companheiro, ambos…',
                resolution_text_3        : 'Selecione uma das opção',

            },

            page_thank_send_email   : 'Le hemos enviado un email a {0} para que te añada los permisos necesarios',
            page_thank_we_wait      : 'Quedamos a la espera de vuestras noticias!',
            page_thank_will_help    : 'Voy a ayudarte con el cambio de propietario de {0}, te contactaré enseguida para empezar el proceso.',
        }
    },

    event : {

        page_related_from_to : 'de {0} a {1}',
        page_related_is_this : 'Solicitar Evento',
        page_related_not_suggested : 'Meu evento não coincide com as sugestões, quero continuar o cadastro:',
        page_related_is_other : 'Não se trata de nenhum destes',

        page_thank_label_1 : 'Olá {0},',
        page_thank_label_2 : 'Nossa equipe de redação está verificando sua solicitação para adicionar este evento ao seu perfil.',
        page_thank_label_3 : 'Em um prazo inferior a 24h ( sem contar feriados ) teremos resolvido ;)',
        page_thank_label_4 : 'Mantemos você informado e convidamos a adicionar outros eventos que você organiza',
        page_thank_label_5 : 'Atenciosamente',
        page_thank_label_6 : 'neventum Equipe Editorial',

        labels : {
            'sector' : 'Setor do evento',
                'periodicity' : 'Periodicidade do evento',
                'scope' : 'Alcance do evento',
                'name' : 'Nome do evento'
        },

        periodicity : {
            mensual : 'Mensal',
            trimestral : 'Trimestral',
            semestral : 'Semestral',
            anual : 'Anual',
            bienal : 'Bienal',
            trienal : 'Trienal',
            cuatrienal : 'Quadrienal',
        },

        scopes : {
            local : 'Local',
                national : 'Nacional',
                international : 'Internacional',
        },

        alerts : {

            related_events_text_1 : '<b>Este é o seu evento?</b>',
            related_events_text_2 : 'Com base na informação que você inseriu, encontramos eventos semelhantes em neventum.',
            related_events_text_3 : 'Para evitar duplicar um evento que já temos em nosso calendário, mostramos a seguir.',
            related_events_text_4 : 'Se você deseja criar um desses eventos, informe-nos e solicite, se quiser, permissão para editá-lo',

        },
    },

    reviews : {

        thanks : 'Obrigada por compartilhar sua opinião',

        labels : {

            rate      : 'Sua qualificação geral',
            opinion   : 'Sua opinião',

            city            : 'Em que cidade se construiu o stand',
            city_stands     : 'Em que cidade se construiu o stand',
            city_catering   : 'Onde foi o evento?',
            city_hostesses  : 'Em que cidade solicitou seus(as) Promotores(as)',

            worked_at            : 'Quando se contruiu o stand',
            worked_at_stands     : 'Quando se contruiu o stand',
            worked_at_catering   : 'Quando foi o evento?',
            worked_at_hostesses  : 'Quando foi o evento?',

            name      : 'Seu nome',
            email     : 'Seu email',
            anonymous : 'Quero que essa opinião seja anônima, meu nome não aparecerá e o fornecedor não será comunicado sobre o que estou opinando',
            accept    : 'Certifico que esta opinião está baseada em minha experiência e se trata de minha opinião genuína sobre este fornecedor, que não tenho nenhuma relação pessoal ou comercial com o mesmo, nem que me ofereceram nenhum tipo de incentivo ou pagamento para escrever esta opinião. Compreendo que neventum possui uma política de tolerância zero com as opiniões falsas.',
            submit    : 'Envie sua opinião',
        },

        help : {
            name  : 'Seu nome não será público se você nos indicar',
            email : 'Esta informação NUNCA será pública',
        },
    },

    rate : {
        label           : 'Haz clic para puntuar',
        label_bad       : 'Bad',
        label_poor      : 'Poor',
        label_fair      : 'Fair',
        label_good      : 'Good',
        label_excellent : 'Excellent',
    },

    cookie : {
        text            : 'As cookies recolhem informação de seu navegador web para oferecer uma melhor experiência online. Em Neventum utilizamos cookies, se continuas navegando consideramos que aceitas seu uso.',
        label_accept    : 'Aceitar',
        label_info      : 'Mais informação',
    },

    session : {
        login :     'Iniciar sessão',
        register :  'Cadastrar-se',
    },
};



// WEBPACK FOOTER //
// ./resources/js/i18n/pt.js